export class NotificationSettingItemModel {
  notificationType: string;
  displayName: string;
  description: string;
  supportsInApp: boolean;
  supportsEmail: boolean;
  inAppEnabled: boolean;
  emailEnabled: boolean;
}
